
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/responsive-preview",
      function () {
        return require("private-next-pages/responsive-preview.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/responsive-preview"])
      });
    }
  